import { render, staticRenderFns } from "./UserTaskListeners.vue?vue&type=template&id=4f200258&"
import script from "./UserTaskListeners.vue?vue&type=script&lang=js&"
export * from "./UserTaskListeners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports